import { initAccCarousel } from '@theme/acc-carousel';

const cleanupRecipeCarousel = (section) => {
  section.__accCarouselCleanup?.();
  section.__accCarouselCleanup = null;
  section.dataset.accCarouselReady = 'false';
  section.dataset.accCarouselScrollable = 'pending';
};

const initRecipeCarousel = (section) => {
  cleanupRecipeCarousel(section);

  if (section.dataset.accCarouselEnabled !== 'true') return;

  const track = section.querySelector('[data-acc-carousel-track]');
  const cardCount = track?.querySelectorAll('.acc-recipe-carousel__card').length ?? 0;

  if (!track || cardCount <= 1) return;

  const previous = section.querySelector('[data-acc-carousel-prev]');
  const next = section.querySelector('[data-acc-carousel-next]');

  if (!previous || !next) return;

  track.scrollLeft = 0;
  section.dataset.accCarouselReady = 'true';
  section.__accCarouselCleanup = initAccCarousel({
    root: section,
    track,
    prevBtn: previous,
    nextBtn: next,
    slideSelector: '.acc-recipe-carousel__card',
    onStateChange: ({ hasOverflow, atStart, atEnd }) => {
      section.dataset.accCarouselScrollable = hasOverflow ? 'true' : 'false';
      previous.hidden = !hasOverflow || atStart;
      next.hidden = !hasOverflow || atEnd;
    },
  });
};

const initRecipeCarouselsWithin = (root = document) => {
  root.querySelectorAll('.acc-recipe-carousel').forEach(initRecipeCarousel);
};

const cleanupRecipeCarouselsWithin = (root) => {
  root?.querySelectorAll('.acc-recipe-carousel').forEach(cleanupRecipeCarousel);
};

const getShopifySectionRoot = (event) => {
  if (event.target instanceof Element && event.target.classList.contains('shopify-section')) {
    return event.target;
  }

  const sectionId = event.detail?.sectionId;
  if (!sectionId) return null;

  return document.getElementById(`shopify-section-${sectionId}`);
};

initRecipeCarouselsWithin(document);

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const root = getShopifySectionRoot(event);
    if (root) {
      initRecipeCarouselsWithin(root);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = getShopifySectionRoot(event);
    if (root) {
      cleanupRecipeCarouselsWithin(root);
    }
  });
}
